import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { InstantBillPaymentInfo } from '.';
import { PricePipe } from '../common/pipes/price.pipe';
import { SubscriptionTierModule } from '../subscription-tier/subscription-tier.module';
import { CheckoutDialogComponent } from './checkout-dialog.component';
import { CheckoutService } from './checkout.service';

@NgModule({
  imports: [
    CommonModule,
    MatCheckboxModule,
    MatDialogModule,
    MatButtonModule,
    MatTooltipModule,
    SubscriptionTierModule,
    GalaxyAlertModule,
    TranslateModule,
    RouterModule,
    MatIconModule,
    ReactiveFormsModule,
    PricePipe,
  ],
  exports: [InstantBillPaymentInfo],
  declarations: [InstantBillPaymentInfo, CheckoutDialogComponent],
  providers: [CheckoutService],
})
export class CheckoutModule {}
